import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.41 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H11.59C11.8523 4.0011 12.1037 4.10526 12.29 4.29L13.71 5.71C13.8963 5.89474 14.1477 5.9989 14.41 6ZM12.8536 13.8536C12.9473 13.7598 13 13.6326 13 13.5V12.5C13 12.3674 12.9473 12.2402 12.8536 12.1464C12.7598 12.0527 12.6326 12 12.5 12H10V9.5C10 9.36739 9.94732 9.24021 9.85355 9.14645C9.75979 9.05268 9.63261 9 9.5 9H8.5C8.36739 9 8.24021 9.05268 8.14645 9.14645C8.05268 9.24021 8 9.36739 8 9.5V12H5.5C5.36739 12 5.24021 12.0527 5.14645 12.1464C5.05268 12.2402 5 12.3674 5 12.5V13.5C5 13.6326 5.05268 13.7598 5.14645 13.8536C5.24021 13.9473 5.36739 14 5.5 14H8V16.5C8 16.6326 8.05268 16.7598 8.14645 16.8536C8.24021 16.9473 8.36739 17 8.5 17H9.5C9.63261 17 9.75979 16.9473 9.85355 16.8536C9.94732 16.7598 10 16.6326 10 16.5V14H12.5C12.6326 14 12.7598 13.9473 12.8536 13.8536Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgFolderAdd = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgFolderAdd;
